module.exports = __webpack_public_path__ + "img/NL.2c77288e.png";